import React, { useState, useEffect } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    ListItemText,
    Input
} from "@mui/material";
import { Card, Alert } from "reactstrap";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import CustomButton from '../../components/CustomButton/CustomButton';
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from 'react-redux';
import { getWalletOwnerIdAndNameList } from '../../redux/actions/getWalletOwnerIdAndNameListAction';
import { adminGetAccountTypeList } from '../../redux/actions/adminGetAccountTypeListAction';
import { accountTypeMappingAdmin } from '../../redux/actions/accountTypeMappingAdminAction';
import { listAccountTypeMapping } from '../../redux/actions/listAccountTypeMappingAction';
import { Delete } from '@mui/icons-material';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import { deleteAccountTypeMapping } from '../../redux/actions/deleteAccountTypeMappingAdminAction';
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getAccountTypeAdmin } from '../../redux/actions/getAccountTypeAdminAction';
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminAccountTypeMapping = () => {

    const classes = useStyles();

    const [walletOwnerID, setwalletOwnerID] = useState('');
    const [bankType, setbankType] = useState('')
    const [walletOwnerIdResp, setwalletOwnerIdResp] = useState([]);
    const [bankTypeList, setbankTypeList] = useState([]);
    const [accountType, setaccountType] = useState('');
    const [accountTypeList, setaccountTypeList] = useState([]);
    const [createSet, setcreateSet] = useState(false);
    const [createDescription, setcreateDescription] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [deleteNotification, setdeleteNotification] = useState(false);
    const [searchWalletOwnerID, setsearchWalletOwnerID] = useState('');
    const [isLoading, setisLoading] = useState(false);
    const [searchSet, setsearchSet] = useState(false);
    const [tableMappingData, settableMappingData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [deleteSet, setdeleteSet] = useState(false);
    const [deleteDescription, setdeleteDescription] = useState('');
    const [acTypeSel, setacTypeSel] = useState(false);

    const getWalletOwnerIdRes = useSelector(({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList);
    const adminGetAccountTypeListRes = useSelector(({ adminGetAccountTypeList }) => adminGetAccountTypeList);
    const accountTypeMappingAdminRes = useSelector(({ accountTypeMappingAdmin }) => accountTypeMappingAdmin);
    const listAccountTypeMappingRes = useSelector(({ listAccountTypeMapping }) => listAccountTypeMapping);
    const getAccountTypeAdminRes = useSelector(({ getAccountTypeAdmin }) => getAccountTypeAdmin);
    const deleteAccountTypeMappingRes = useSelector(({ deleteAccountTypeMapping }) => deleteAccountTypeMapping);
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    var authToken = regenerateTokenRes.data.AuthToken;

    const dispatch = useDispatch();

    const selAccountType = () => {
        setacTypeSel(true);
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                accountName: ""
            }
        }
        dispatch(getAccountTypeAdmin(req, authToken));
    }

    const setAccountTypeDropdownValues = () => {
        if (acTypeSel) {
            if (getAccountTypeAdminRes.data.status === 'success') {
                setaccountTypeList(getAccountTypeAdminRes.data.list);
            }
            if (getAccountTypeAdminRes.data.status === 'failed') {
                if (
                    getAccountTypeAdminRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getAccountTypeAdminRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        setAccountTypeDropdownValues()
    }, [getAccountTypeAdminRes.data.status]);

    const deleteMappingRespFunc = () => {
        if (deleteSet) {
            if (deleteAccountTypeMappingRes.data.status === 'success') {
                setdeleteDescription(deleteAccountTypeMappingRes.data.description);
                setdeleteNotification(true);
                submitsearchfunc()
            }
            if (deleteAccountTypeMappingRes.data.status === 'failed') {
                setdeleteDescription(deleteAccountTypeMappingRes.data.description);
                setdeleteNotification(true);
                if (
                    deleteAccountTypeMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    deleteAccountTypeMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        deleteMappingRespFunc();
    }, [deleteAccountTypeMappingRes.data.status])

    const disAcList = (wid, btype, mar, aclist) => {
        let mapped = [].concat(mar).filter(ch => ch.walletOwnerId === wid && ch.bankType === btype).map(x => x.name);
        for (let i = 0; i < aclist.length; i++) {
            aclist[i].disabled = false;

            for (let j = 0; j < mapped.length; j++) {
                if (aclist[i].accountName === mapped[j]) {
                    aclist[i].disabled = true;
                    break;
                }
            }
        }
        setaccountTypeList(aclist);
    }

    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'walletOwnerID') {
            selAccountType();
            setwalletOwnerID(value);
            setbankType('');
            setaccountType('')
        }
        if (name === 'bankType') {
            setbankType(value);
            disAcList(walletOwnerID, value.split('-')[1], tableMappingData, accountTypeList);
            setaccountType('');
        }
        if (name === 'accountType') {
            if (value.includes('all')) {
                setaccountType(
                    accountType.length === accountTypeList.filter(ch => !ch.disabled).length
                        ? []
                        : accountTypeList.filter(ch => !ch.disabled).map((x) => x.accountName)
                )
            } else {
                setaccountType(value);
            }
        }
    }

    const createAccountTypeMappingFunc = () => {
        setcreateSet(true);
        const getIds = (ma, ar) => {
            let fa = [];
            let maKey = ma.map(x => x.accountName);
            for (let i = 0; i < ar.length; i++) {
                fa.push(ma[maKey.indexOf(ar[i])].id)
            }
            return fa;
        }
        const req = {
            actionCustomerMasterRequestVO: {
                accId: getIds(accountTypeList, accountType).length == 0 ? '' : getIds(accountTypeList, accountType),
                bankId: bankType === '' ? '' : bankType.split('-')[0],
                walletOwnerId: walletOwnerID,
            }
        }
        dispatch(accountTypeMappingAdmin(req, authToken));
        setwalletOwnerID('')
        setbankType('')
        setaccountType('')
    }



    const getAllData = () => {
        setisLoading(true)
        setsearchSet(true);
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: ''
            }
        }
        dispatch(listAccountTypeMapping(req, authToken));
    }

    const createRespFunc = () => {
        if (createSet) {
            if (accountTypeMappingAdminRes.data.status === 'success') {
                setcreateDescription(accountTypeMappingAdminRes.data.description);
                getAllData();
                setnotificationOpen(true);
            }
            if (accountTypeMappingAdminRes.data.status === 'failed') {
                setcreateDescription(accountTypeMappingAdminRes.data.description);
                setnotificationOpen(true);
                if (
                    accountTypeMappingAdminRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    accountTypeMappingAdminRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        createRespFunc();
    }, [accountTypeMappingAdminRes.data.status]);

    useEffect(() => {
		if (accountTypeMappingAdminRes.data.status == "success") {
			setPage(0);
		}
	}, [accountTypeMappingAdminRes.data.status]);

    const getWalletOwnerIdFunc = () => {
        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: regenerateTokenRes.data.partnerId
                            adminId:val.adminIDS
                    }
                },
                authToken
            )
        )
    }

    useEffect(() => {
        getWalletOwnerIdFunc();
    }, [authToken])

    useEffect(() => {
        if (getWalletOwnerIdRes.data.status === 'success') {
            setwalletOwnerIdResp(getWalletOwnerIdRes.data.ownerList);
        }
        if (getWalletOwnerIdRes.data.status === 'failed') {
            if (
                getWalletOwnerIdRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getWalletOwnerIdRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [getWalletOwnerIdRes.data.status]);

    const getAccountTypeList = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                accountName: ""
            }
        }
        dispatch(adminGetAccountTypeList(req, authToken))
    }

    useEffect(() => {
        getAccountTypeList();
    }, []);

    useEffect(() => {
        submitsearchfunc();
    }, [])

    const setBankTypeListFunc = () => {
        if (adminGetAccountTypeListRes.data.status === 'success') {
            setbankTypeList(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList);
        }
        if (adminGetAccountTypeListRes.data.status === 'failed') {
            if (
                adminGetAccountTypeListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                adminGetAccountTypeListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }

    useEffect(() => {
        setBankTypeListFunc();
    }, [adminGetAccountTypeListRes.data.status]);

    const handleNoticationClose = () => {
        setnotificationOpen(false);
    }

    const chagneSearchWalletOwnerId = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'searchWalletOwnerID') {
            setsearchWalletOwnerID(value)
        }
    }

    const submitsearchfunc = () => {
        setisLoading(true)
        setsearchSet(true);
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: searchWalletOwnerID === 'Select Owner Id' ? '' : searchWalletOwnerID
            }
        }
        dispatch(listAccountTypeMapping(req, authToken));
        setPage(0);
    }

    const setAccountTypeMappingListFunc = () => {
        if (searchSet) {
            if (listAccountTypeMappingRes.data.status === 'success') {
                settableMappingData([].concat(listAccountTypeMappingRes.data.list));
                setisLoading(false);
                setsearchSet(false)
            }
            if (listAccountTypeMappingRes.data.status === 'failed') {
                settableMappingData([]);
                setisLoading(false);
                setsearchSet(false)
                if (
                    listAccountTypeMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    listAccountTypeMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        setAccountTypeMappingListFunc();
    }, [listAccountTypeMappingRes.data.status]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const deleteModal = id => {
        setdeleteSet(true)
        const req = {
            actionCustomerMasterRequestVO: {
                mappingId: id
            }
        }
        dispatch(deleteAccountTypeMapping(req, authToken));
        setwalletOwnerID('');
        setbankType('');
        setaccountType('');
    }

    const deleteNotificationClose = () => {
        setdeleteNotification(false);
    }

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <DialogTitle>Mapping Account Type</DialogTitle>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Select Owner Id"
                                fullWidth={true}
                                name="walletOwnerID"
                                value={walletOwnerID || ""}
                                onChange={handleChange}
                            >
                                <MenuItem value="" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {walletOwnerIdResp &&
                                    [].concat(walletOwnerIdResp).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                variant='standard'

                                type="text"
                                label="Select Bank Type"
                                fullWidth={true}
                                name="bankType"
                                value={bankType || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value=""
                                    selected="Select Bank Type"
                                >
                                    Select Bank Type
                                </MenuItem>
                                {bankTypeList &&
                                    [].concat(bankTypeList).map((x, index) => (
                                        <MenuItem key={index} value={`${x.id}-${x.accountName}`}>
                                            {x.accountName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <FormControl className={classes.formControl} style={{ width: '100%', marginTop: '-4px' }}>
                                <InputLabel id='multipleCountrySelect'>Select Account Type</InputLabel>
                                <Select
                                    labelId='multipleCountrySelect'
                                    multiple
                                    fullWidth={true}
                                    variant='standard'

                                    value={accountType || []}
                                    name='accountType'
                                    input={<Input />}
                                    renderValue={selected => selected.join(', ')}
                                    onChange={handleChange}
                                >
                                    <MenuItem key='all' value='all'>
                                        <Checkbox color='primary' checked={accountType.length === accountTypeList.filter(ch => !ch.disabled).length} />
                                        <ListItemText primary='Select All' />
                                    </MenuItem>
                                    {
                                        accountTypeList && [].concat(accountTypeList).map((x, index) => {
                                            return (
                                                <MenuItem key={index} value={`${x.accountName}`} disabled={x.disabled}>
                                                    <Checkbox color='primary' checked={accountType.indexOf(`${x.accountName}`) > -1} />
                                                    <ListItemText primary={x.accountName} />
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={createAccountTypeMappingFunc}
                            >
                                Create
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                <Card>
                    <DialogTitle>Search</DialogTitle>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                variant='standard'
                                type="text"
                                label="Owner ID"
                                fullWidth={true}
                                name="searchWalletOwnerID"
                                value={searchWalletOwnerID || "Select Owner Id"}
                                onChange={chagneSearchWalletOwnerId}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {walletOwnerIdResp &&
                                    [].concat(walletOwnerIdResp).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={submitsearchfunc}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                {
                    isLoading ? (<LoadingSpinner />) : tableMappingData == undefined || !tableMappingData || tableMappingData.length == 0 ? (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                className="themeText"
                                    
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Alert
                                        className="my-3 tableHeaderColor"
                                        variant="secondary"
                                        style={{ color: "white" }}
                                    >
                                        No Records Found!
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Card>
                    ) : (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                className="themeText"
                                    
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table
                                        className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Mapping ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Type
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Account Type
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Owner Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {tableMappingData &&
                                                []
                                                    .concat(tableMappingData)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center"> {row.mappingId} </TableCell>
                                                            <TableCell align="center"> {row.bankType} </TableCell>
                                                            <TableCell align="center"> {row.name} </TableCell>
                                                            <TableCell align="center">{row.walletOwnerName}</TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => deleteModal(row.mappingId)}
                                                                >
                                                                    <Delete style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(tableMappingData).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    )
                }
            </Layout>

            {accountTypeMappingAdminRes.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {createDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {accountTypeMappingAdminRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {createDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {deleteAccountTypeMappingRes.data.status == "success" && (
                <div>
                    <Dialog open={deleteNotification} onClose={deleteNotificationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={deleteNotificationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {deleteAccountTypeMappingRes.data.status == "failed" && (
                <div>
                    <Dialog open={deleteNotification} onClose={deleteNotificationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={deleteNotificationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminAccountTypeMapping;